// extracted by mini-css-extract-plugin
export default {"social":"styles_social__IVoWh"};